const rrOverlay = document.querySelector(".js-rr-overlay");

if (typeof rrOverlay != "undefined" && rrOverlay != null) {

    const rrNoBtn = document.querySelector(".js-rr-no-btn"),
          stopScrollingClass = 'stop-scrolling';

    body.classList.add(stopScrollingClass);
    rrNoBtn.addEventListener("click", () => {
        gsap.to(rrOverlay, 0.3, { autoAlpha: 0, ease: Power1.easeInOut });
        body.classList.remove(stopScrollingClass);
    });
}